export const bytesToGB = ({ bytes }) => {
  return bytes / (1024 * 1024 * 1024);
};
